import React, { ReactElement } from 'react';
import { addMonths, format } from 'date-fns';
import { es } from 'date-fns/locale';
import { CalendarToolbar, SummaryItem } from '../CalendarToolbar/CalendarToolbar';
import { calendarMessages } from '../../utils/calendarUtils';
import { ActivityTimeline, ActivityTimelineItem } from './ActivityTimeline';

/** The list view of a month of activity: the same toolbar as the calendar (month, arrows, summary) over a timeline. */
export const ActivityList = ({
  date,
  onNavigate,
  items,
  summaryItems,
  customSummaryItems,
}: {
  date: Date;
  onNavigate: (date: Date) => void;
  items: ActivityTimelineItem[];
  summaryItems?: SummaryItem[];
  customSummaryItems?: ReactElement[];
}) => (
  <div className='activity-list'>
    <CalendarToolbar
      date={date}
      localizer={{ messages: calendarMessages }}
      label={format(date, 'MMMM yyyy', { locale: es })}
      // The toolbar has only the two arrows.
      onNavigate={(action) => onNavigate(addMonths(date, action === 'PREV' ? -1 : 1))}
      summaryItems={summaryItems}
      customSummaryItems={customSummaryItems}
    />
    <ActivityTimeline items={items} emptyMessage='No hay actividad en este mes' />
  </div>
);
